import axios from "axios";
import router from "@/router";
import i18n from "../../i18n";
export default {
  state: {
    isThinking: false,
    searchByLinkId: "",
  },
  getters: {
    getIsThinking: (state) => state.isThinking,
    getSearchByLinkId: (state) => state.searchByLinkId,
  },
  mutations: {
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setSearchByLinkId(state, linkId) {
      state.searchByLinkId = linkId;
    },
  },
  actions: {
    getAIResponse({ getters, dispatch, commit }, question) {
      if (question) {
        commit("setIsThinking", true);
      }
      let data;
      if (getters.getCurrentLanguage === "en") {
        data = JSON.stringify({
          question: question,
          lang: "english",
          client: "dekalbwf"
        });
      } else {
        data = JSON.stringify({
          question: question,
          lang: "spanish",
          client: "dekalbwf"
        });
      }

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          let aiResponse = response.data.answer;
          dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "QnA",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Speech",
              elementContent: {
                question: question,
                answer: aiResponse.response,
                confidenceScore: 1,
              },
            },
          });
          dispatch("addQnaDatatoStrapi", {
            timeStamp: new Date(),
            kioskID: getters.getKioskId,
            transcript: question,
            result: {
              answers: [
                {
                  questions: [question],
                  answer: aiResponse.response,
                  confidenceScore: 1,
                },
              ],
            },
          });
          dispatch("addUserSessionToStrapi", {
            applicationId: getters.getKioskProfile.data().applicationId,
            applicationSessionId: getters.getSessionId,
            timeStamp: new Date(),
            actionType: "QnA",
            sessionPayload: {
              module: "AI",
              action: question,
              response: aiResponse.response,
            },
          });
          commit("setIsThinking", false);
          if (aiResponse.intent === "followup") {
            dispatch("avatarSpeak", aiResponse.response);
            let followupList = i18n.t("whatcanyoudo").split(",");
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("selectOptionMsg"),
              dialogData: followupList,
            });
          } else if (aiResponse.intent === "speak") {
            dispatch("avatarSpeak", aiResponse.response);
          } else if (aiResponse.intent === "showmap") {
            let mapPath = "";
            if (getters.getCurrentLanguage === "en") {
              mapPath = i18n
                .t("maps")
                .filter(
                  (map) =>
                    map.mapName.toLowerCase() ===
                    aiResponse.metadata.mappath.toLowerCase()
                );
            } else {
              let mapPath1 = getters.getMaps.get(
                aiResponse.metadata.mappath.toLowerCase()
              );
              mapPath = i18n
                .t("maps")
                .filter(
                  (map) => map.displayPosition === mapPath1.displayPosition
                );
            }
            if ("source" in aiResponse.metadata) {
              dispatch("avatarSpeak", mapPath[0].speech);
            } else {
              dispatch(
                "avatarSpeak",
                aiResponse.response + " " + mapPath[0].speech
              );
            }

            dispatch("findFloor", mapPath[0].mapFloor).then((response) => {
              dispatch("openImageViewer", {
                name: mapPath[0].mapName,
                url: mapPath[0].mapImage,
                floor: response,
              });
            });
          } else if (aiResponse.intent === "searchbylinkid") {
            commit("setSearchByLinkId", "");
            router.addRoute({
              path: "/faqs",
              component: () => import("@/views/faqs"),
            });
            if (router.currentRoute.path !== "/faqs") {
              router.push("/faqs");
            }
            var page = i18n
              .t("homepages")
              .filter((page) => page.pageType[0].pathName === "faqs");
            commit("setPageHeader", page[0].pageType[0].pageHeader);
            commit("setSearchByLinkId", aiResponse.metadata.linkid);
            dispatch("avatarSpeak", aiResponse.response);
          } else if (aiResponse.intent === "navigate") {
            dispatch("avatarSpeak", aiResponse.response);
            let page = i18n
              .t("homepages")
              .filter(
                (page) => page.pageType[0].pathName === aiResponse.metadata.path
              );
            commit("setPageHeader", page[0].pageType[0].pageHeader);
            router.push("/" + aiResponse.metadata.path);
          } else if (aiResponse.intent === "fallback") {
            if (
              aiResponse.metadata.questiontype.toLowerCase() === "court" ||
              aiResponse.metadata.questiontype.toLowerCase() === "county"
            ) {
              dispatch("avatarSpeak", aiResponse.response);
              let defaultMap = i18n
                .t("maps")
                .filter(
                  (map) =>
                    map.mapName.toLowerCase() ===
                    getters.getDefaultLocation.toLowerCase()
                );
              dispatch("findFloor", defaultMap[0].mapFloor).then((response) => {
                dispatch("openImageViewer", {
                  name: defaultMap[0].mapName,
                  url: defaultMap[0].mapImage,
                  floor: response,
                });
              });
              dispatch("avatarSpeak", i18n.t("mapNotFound"));
            } else {
              dispatch("avatarSpeak", aiResponse.response);
            }
          } else {
            commit("setIsThinking", false);
            if (getters.getKioskProfile.data().kioskPremise === "Inside") {
              dispatch("avatarSpeak", i18n.t("noAnswerFound"));
              commit("setTelepresenceViewer", true);
            } else {
              commit("setHelpViewer", true);
            }
          }
        })
        .catch((error) => {
          dispatch("avatarSpeak", "Something went wrong. Please try again.");
          commit("setIsThinking", false);
        });
    },
  },
};
